<div class="no-payment-alert" *ngIf="(subscriptionStatus$ | async) === 'InGracePeriod'">
    Your account is past due. You will be locked out in {{daysToFailure$ | async}} days.<a href="/Company/Company/Dashboard">Click here to update your subscription.</a>
</div>